import { ThemeProvider } from '@emotion/react';
import Grid from '@mui/material/Grid';
import { createTheme, styled } from '@mui/material/styles';
import { getUsersNfts } from 'APIs/HotAuctionApi';
import Loader from 'components/atoms/loader';
import GalleryCards from 'components/molecules/Card/GalleryCards';
import NftData from 'interfaces/NftData.interface';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const Body = styled(Grid)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  paddingTop: '15px',
  paddingBottom: '100px',
  paddingLeft: '20px',
  paddingRight: '20px',
  gap: '6px',
}));

const divStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '10px',
  margin: '10px 5px',
} as React.CSSProperties;

const GalleryBody = () => {
  const history = useNavigate();
  const [nfts, setNfts] = React.useState<NftData[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const location = useLocation();
  React.useEffect(() => {
    const getNfts = async () => {
      setLoading(true);
      const data = await getUsersNfts(location.pathname.split('/')[2]);
      setNfts(data.data);
      setLoading(false);
    };
    getNfts();
    //eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Body container>
          <div style={divStyles} onClick={() => history('/explore/otr')}>
            {loading ? (
              <Loader
                size="0.8"
                sx={{
                  width: '90vw',
                  minHeight: '500px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              />
            ) : (
              nfts.map(nft => {
                return (
                  <Grid item key={nft.id}>
                    <GalleryCards views={nft.views} image={nft.poster} />
                  </Grid>
                );
              })
            )}
          </div>
        </Body>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default GalleryBody;
